module.exports = __webpack_public_path__ + "media/images/logos/University-of-Columbia-e0bef70610374c04238bdc50baffbd21.svg";